module.exports = __webpack_public_path__ + "static/media/img_11.e3ab5e7a.png";